import BaseRequest from './BaseRequest';
import { API_URL } from '../config/config';

const SolicitacaoEmprestimoRequest = () => {
    return {
        buscarInformacoesAcervoSolicitacaoEmprestimo(
            codAcervo,
            campus = null,
            bibliotecas = null,
        ) {
            return BaseRequest.axiosInst.get(
                `${API_URL}/solicitacao-emprestimo/${codAcervo}/informacoes-iniciais`,
                {
                    headers: BaseRequest.publicHeaders,
                    params: {
                        campus,
                        bibliotecas,
                    },
                },
            );
        },
        gravarSolicitacao(
            codAcervo,
            bibOrigem,
            bibRecebimento,
            volume,
            tomo,
            parte,
            matAdicional,
            telefone,
            email,
            codDepRecebimento,
            pessoaAutorizada,
            domicilio,
            recebimento_textual,
        ) {
            return BaseRequest.axiosInst.post(
                `${API_URL}/solicitacao-emprestimo/${codAcervo}`,
                {
                    biblioteca_origem: bibOrigem || null,
                    biblioteca_recebimento: bibRecebimento || null,
                    volume,
                    tomo,
                    parte,
                    material_adicional: matAdicional,
                    telefone: telefone || null,
                    email: email || null,
                    cod_local_recebimento: codDepRecebimento || null,
                    pessoa_autorizada: pessoaAutorizada || null,
                    domicilio: domicilio || null,
                    recebimento_textual: recebimento_textual || null,
                },
                { headers: BaseRequest.privateHeaders() },
            );
        },
        buscarSolicitacoesEmprestimoUsuario(dataIni, dataFim, status) {
            return BaseRequest.axiosInst.get('/api/solicitacao-emprestimo', {
                headers: BaseRequest.privateHeaders(),
                params: { dataIni, dataFim, status },
            });
        },
        getWarningMessage(cod_biblioteca) {
            return BaseRequest.axiosInst.get(
                '/api/solicitacao-emprestimo/get-warning-message',
                {
                    headers: BaseRequest.publicHeaders,
                    params: { cod_biblioteca },
                },
            );
        },
        getLabelPersonAuthorized(cancelToken = null) {
            return BaseRequest.axiosInst.get(
                '/api/solicitacao-emprestimo/get-label-person-authorized',
                {
                    headers: BaseRequest.publicHeaders,
                    cancelToken,
                },
            );
        },
        getRulePhoneAndEmail(cancelToken = null) {
            return BaseRequest.axiosInst.get(
                `${API_URL}/solicitacao-emprestimo/get-rule-phone-and-email`,
                { headers: BaseRequest.publicHeaders },
                cancelToken,
            );
        },
        getSolicitacaoEmprestimoLabels(cancelToken = null) {
            return BaseRequest.axiosInst.get(
                `${API_URL}/solicitacao-emprestimo/get-labels`,
                { headers: BaseRequest.publicHeaders },
                cancelToken,
            );
        },
    };
};

export default SolicitacaoEmprestimoRequest();
